import React from "react";
import classNames from "classnames";

import { TalkInfoCard } from "content-ui/talks/components/eventPage/talkInfoCard";
import { TalkPeople } from "components/talkPeople";
import { useMixpanelTracking } from "lib/hooks/useMixpanelTracking";
import { DiscussionList } from "content-ui/talks/components/eventPage/discussionList";
import DetailHero from "content-ui/talks/components/detailHero/detailHero";

import type { TalkData } from "content-ui/talks/types";
import ButtonBack from "components/buttonBack/buttonBack";

const TalkEventView = ({
  talk,
  allTalks,
}: {
  talk: TalkData;
  allTalks: TalkData[];
}) => {
  const { track } = useMixpanelTracking();
  return (
    <main className="w-100 bg-[#F4F4F6] pt-[65px] text-black-rock">
      <div className="mx-auto max-w-[1040px] px-5 pb-[100px] lg:w-full lg:max-w-[1220px] lg:px-0">
        <div className="mt-10 flex flex-col items-center">
          <div className="flex w-full flex-col">
            <div className={"mb-[10px]"}>
              <ButtonBack href={"/talks"} component={"link"}>
                Back to the list
              </ButtonBack>
            </div>
            <section className={"mb-[30px] text-black-rock lg:mb-10"}>
              <DetailHero {...talk} />
            </section>
          </div>
          <div
            className={classNames("grid w-full gap-[40px]", {
              "[grid-template-areas:'about''sidebar''info''moderators'] lg:[grid-template-areas:'about_sidebar''info_sidebar''moderators_moderators']":
                talk.about,
              "[grid-template-areas:'sidebar''info'] lg:[grid-template-areas:'info_sidebar']":
                !talk.about,
            })}
          >
            {talk.about && (
              <div className={"flex flex-col [grid-area:about]"}>
                <h3
                  className={"mb-[10px] font-bold text-[16px] leading-[130%]"}
                >
                  {talk.aboutSectionHeading}
                </h3>
                <p className="text-[16px] leading-[130%] text-mono-70">
                  {talk.about}
                </p>
              </div>
            )}
            <div
              className={classNames(
                "flex flex-none flex-col gap-[10px] text-black-rock [grid-area:sidebar]",
                {
                  "lg:w-[330px]": talk.about,
                  "w-full": !talk.about,
                }
              )}
            >
              <TalkInfoCard talk={talk} allTalks={allTalks} />
            </div>
            {talk.discussing && (
              <div className={"flex flex-col [grid-area:info]"}>
                <h2 className="mb-[10px] font-bold text-[16px]">
                  {talk.agendaSectionHeading}
                </h2>
                <DiscussionList text={talk.discussing} />
              </div>
            )}
            {talk.people.length > 0 && (
              <div className={"flex flex-col [grid-area:moderators]"}>
                <h2 className="mb-[10px] font-bold text-[16px]">
                  {talk.peopleSectionHeading}
                </h2>
                <TalkPeople
                  people={talk.people}
                  onPersonContactClick={async (person) =>
                    track("Talks user link click", {
                      "Click link": person.linkedinUrl || person.twitterUrl,
                      "Click text": person.name,
                    })
                  }
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </main>
  );
};
export default TalkEventView;
